import React from 'react';

import { DashboardCVAdminContext } from 'src/providers/DashboardCVAdminProvider';

export const useDashboardCVAdminData = () => {
  return React.use(DashboardCVAdminContext);
};
